// src/components/TeamPage.jsx

import { useState } from 'react';
import { teamMembers } from '../Data/team.js';
import TeamMemberCard from './TeamMemberCard.jsx';
import SEOHelmet from './SEOHelmet';

function TeamPage() {
  const [showAll, setShowAll] = useState(false);

  // Determine which members to display
  const membersToShow = showAll ? teamMembers : teamMembers.slice(0, 3);

  return (
    <>
      <SEOHelmet
        title="Our Team - Meet the Torque Energy Experts"
        description="Meet the innovators and hard workers behind Torque Energy. Learn about our talented team dedicated to bringing you clean, sustained energy."
        keywords="torque team, energy drink team, about torque energy, meet the team, contact torque"
        url="https://torqueenergy.shop/team"
      />
      <div className="container team-page-container">
        <h2>Meet the Team</h2>
        <p className="team-intro">The innovators and hard workers behind Torque Energy.</p>

        <div className="team-grid">
          {membersToShow.map(member => (
            <TeamMemberCard key={member.id} member={member} />
          ))}
        </div>

        {/* Conditionally render the "View All" button */}
        {!showAll && teamMembers.length > 3 && (
          <div className="view-all-container">
            <button className="view-all-btn" onClick={() => setShowAll(true)}>
              View All Members
            </button>
          </div>
        )}
      </div>
    </>
  );
}

export default TeamPage;